import { useState, useEffect } from 'react'
import { authHeaders } from '../utils/authFetch' // adjust path to match this file's location relative to utils/

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

export function useAIHistory(endpoint = 'customer-intelligence-history') {
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchHistory = async () => {
        setLoading(true)
        try {
            const res = await fetch(`${BASE_URL}/api/${endpoint}`, { headers: authHeaders() })
            if (res.ok) setHistory(await res.json())
        } catch (err) {
            console.error('fetchHistory error:', err)
        }
        setLoading(false)
    }

    const saveAnalysis = async ({ summary, recommendations, branchName, dateRange, startISO, endISO }) => {
        try {
            const res = await fetch(`${BASE_URL}/api/${endpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    summary,
                    recommendations,
                    branchName,
                    dateRange,
                    startISO,
                    endISO,
                }),
            })
            if (!res.ok) return { data: null, error: 'Failed to save analysis' }
            const data = await res.json()
            setHistory(prev => [data, ...prev])
            return { data, error: null }
        } catch (err) {
            console.error('saveAnalysis error:', err)
            return { data: null, error: err.message }
        }
    }

    const deleteAnalysis = async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/api/${endpoint}/${id}`, { method: 'DELETE', headers: authHeaders() })
            if (!res.ok) return { error: 'Failed to delete analysis' }
            setHistory(prev => prev.filter(h => h.id !== id))
            return { error: null }
        } catch (err) {
            console.error('deleteAnalysis error:', err)
            return { error: err.message }
        }
    }

    useEffect(() => {
        fetchHistory()
    }, [])

    return { history, loading, saveAnalysis, deleteAnalysis, fetchHistory }
}